import { memo, useMemo } from 'react';
import { Tabs, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { EditProfileMediaTabItem } from './EditProfileMedia.styles';
import { EMediaTabs } from 'shared/enums/EMediaTabs';
import { useEditProfileMediaTab } from '../../hooks/useEditProfileMediaTab';
import EditProfileMediaDocuments from '../EditProfileMediaDocuments/EditProfileMediaDocuments';
import EditProfileMediaResume from '../EditProfileMediaResume/EditProfileMediaResume';
import EditProfileMediaCompositeCard from '../EditProfileMediaCompositeCard/EditProfileMediaCompositeCard';

type EditProfileMediaProps = {
  handleIsCompositeCard: (value: boolean) => void;
};

const EditProfileMedia = ({ handleIsCompositeCard }: EditProfileMediaProps) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up(735));
  const { tabs, currentTab, handleOnChange } = useEditProfileMediaTab(handleIsCompositeCard);

  const renderTabContent = useMemo(() => {
    switch (currentTab) {
      case EMediaTabs.MEDIA_DOCUMENTS:
        return <EditProfileMediaDocuments />;
      case EMediaTabs.RESUME:
        return <EditProfileMediaResume />;
      case EMediaTabs.COMPOSITE_CARD:
        return <EditProfileMediaCompositeCard />;
      default:
        return null;
    }
  }, [currentTab]);

  return (
    <div style={{ minWidth: 0, width: '100%' }}>
      <Tabs
        value={currentTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={(_, newValue: EMediaTabs) => handleOnChange(newValue)}
        variant={matches ? 'standard' : 'fullWidth'}
        style={{ marginTop: matches ? -10 : undefined }}
      >
        {tabs.map((tab) =>
          tab.hide ? null : (
            <EditProfileMediaTabItem
              style={{ textTransform: 'none', padding: 0 }}
              label={tab.name}
              value={tab.value}
              key={tab.value}
            />
          ),
        )}
      </Tabs>
      {renderTabContent}
    </div>
  );
};

export default memo(EditProfileMedia);
